module.exports = __webpack_public_path__ + "media/bootstrap-icons/minecart-b6d446aa.svg";